export const state = {
  schedulingtype: null,
  schedulingtypes: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/schedulingtype/state.js